import React, {forwardRef, useEffect, useRef} from "react";
import {ReactComponent as Gears} from "../assets/gears.svg";

export const GEAR_IDS = ["first_gear", "second_gear", "third_gear", "fourth_gear", "fifth_gear", "sixth_gear"];

/** Maximum questions the gears artwork can visualize. */
export const GEAR_COUNT = GEAR_IDS.length;

interface GearsScoreboardProps {
    /** Per-question results; undefined entries render as unanswered. */
    scoreBoard: Array<boolean | undefined>;
    className?: string;
    id?: string;
}

/**
 * The gears artwork with each gear colored by the matching scoreboard entry.
 * Class changes are scoped to this instance's own SVG element.
 */
export const GearsScoreboard = forwardRef<SVGSVGElement, GearsScoreboardProps>(
    ({scoreBoard, className, id}, forwardedRef) => {
        const svgRef = useRef<SVGSVGElement | null>(null);

        const setRefs = (el: SVGSVGElement | null) => {
            svgRef.current = el;
            if (typeof forwardedRef === "function") {
                forwardedRef(el);
            } else if (forwardedRef) {
                forwardedRef.current = el;
            }
        };

        useEffect(() => {
            const svg = svgRef.current;
            if (!svg) {
                return;
            }
            GEAR_IDS.forEach((gearId, index) => {
                const gear = svg.querySelector(`#${gearId}`);
                gear?.classList.remove("correct", "wrong");
                const result = scoreBoard[index];
                if (result !== undefined) {
                    gear?.classList.add(result ? "correct" : "wrong");
                }
            });
        }, [scoreBoard]);

        return <Gears ref={setRefs} className={className} id={id}/>;
    });
